export default __webpack_public_path__ + "static/media/icomoon-free_move-down.10631273.svg";